import { ChangeEvent, useState } from 'react';
import { Avatar, Box, IconButton, Stack, TextField } from '@mui/material';
import { CommentDto, CreateCommentDto } from '@sr/dto';
import SendIcon from '@mui/icons-material/Send';
import { CommentItem } from 'entities/comments/comment-item';
import { ErrorBanner } from 'shared/ui/error-banner';
import { LoadingBanner } from 'shared/ui/loading-banner';


type Props = {
  comments?: CommentDto[];
  error?: string
  isLoading?: boolean;
  addComment: (dto: CreateCommentDto) => Promise<void>;
}
export const Comments = ({ comments, isLoading, error, addComment }: Props) => {
  const [commentText, setCommentText] = useState('');

  const [posting, setPosting] = useState(false);

  const handleAddComment = async () => {
    setPosting(true);
    await addComment({ content: commentText });
    setCommentText('');
    setPosting(false);
  };

  const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCommentText(e.target.value);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Box>
        <Stack direction="row">
          <Box marginRight={2}>
            <Avatar></Avatar>
          </Box>
          <Box width="100%">
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
              <TextField
                fullWidth
                value={commentText}
                placeholder="Добавить комментарий..."
                rows={1}
                // multiline
                onChange={handleTextChange}
              />
              <IconButton disabled={posting} color="primary" onClick={handleAddComment}>
                <SendIcon />
              </IconButton>
            </Stack>
          </Box>
        </Stack>
      </Box>
      <Box>
        <Stack direction="column" spacing={2}>
          {error && <ErrorBanner errorMessage={error} />}
          {isLoading && <LoadingBanner />}
          {comments?.map((c) => (
            <CommentItem key={c.id} comment={c} />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
};
